import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { SelectDoctorPageComponent } from './select-doctor-page.component';
import { DoctorListPageModule } from '../doctor-list/doctor-list-page.module';
import { DoctorCardModule } from '../../components';
import { LoadingModule } from 'src/app/shared/components';

@NgModule({
    declarations: [
        SelectDoctorPageComponent,
    ],
    exports: [
        SelectDoctorPageComponent,
    ],
    imports: [
        BrowserModule,
        AngularSvgIconModule,
        DoctorListPageModule,
        DoctorCardModule,
        LoadingModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SelectDoctorPageModule { }
